import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.chat');
import { OnInit, Input } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kiosk-chat',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.chat/view.scss */
/* src/app/portal.kiosk.chat/view.scss: no such file or directory */`],
})
export class PortalKioskChatComponent implements OnInit {
    @Input() event: any;
    @Input() opts: any;

    public imageCapture: any;
    public status: any = 'select';
    public countdown: any = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async back() {
        if (this.status == "select") return this.event.view('main');
        this.status = "select";
        await this.service.render();
    }

    public async select(subject: string) {
        this.status = 'chat';
        await this.event.set('subject', subject);
        await this.service.render();
    }

    public async initRecorder() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            this.mediaRecorder = new MediaRecorder(stream);

            this.mediaRecorder.ondataavailable = event => {
                if (event.data && event.data.size > 0) {
                    audioChunks.push(event.data);
                }
            };
        } catch (err) {
            console.error('마이크 접근에 실패했습니다:', err);
        }
    }

    public async startRecord() {
        let root = this;
        const UPLOAD_URL = wiz.url("audio");

        let mediaRecorder, audioChunks = [];
        let audioContext, analyserNode, sourceNode, processorNode;
        let silenceStart = null;
        const SILENCE_THRESH = 0.1;     // RMS 기준 무음 임계값
        const SILENCE_TIMEOUT = 2000;    // 무음 지속 시간(ms)

        async function detectSilence(event) {
            const input = event.inputBuffer.getChannelData(0);
            let sum = 0;
            for (let i = 0; i < input.length; i++) {
                sum += input[i] * input[i];
            }
            const rms = Math.sqrt(sum / input.length);

            console.log(rms);

            if (rms > SILENCE_THRESH) {
                // 소리 감지됨 → 무음 타이머 리셋
                silenceStart = null;
            } else {
                // 무음 상태
                if (silenceStart === null) {
                    silenceStart = performance.now();
                } else if (performance.now() - silenceStart > SILENCE_TIMEOUT) {
                    // 지정 시간 무음 지속 → 녹음 중지
                    await root.stopRecording();
                }
            }
        }

        async function sendAudioToServer() {
            function writeString(view, offset, string) {
                for (let i = 0; i < string.length; i++) {
                    view.setUint8(offset + i, string.charCodeAt(i));
                }
            }

            function audioBufferToWavBlob(buffer) {
                const numChannels = buffer.numberOfChannels;
                const sampleRate = buffer.sampleRate;
                const bitsPerSample = 16;
                const bytesPerSample = bitsPerSample / 8;
                const blockAlign = numChannels * bytesPerSample;
                const byteRate = sampleRate * blockAlign;

                const samplesLength = buffer.length;
                const dataSize = samplesLength * blockAlign;
                const wavBuffer = new ArrayBuffer(44 + dataSize);
                const view = new DataView(wavBuffer);

                // RIFF header
                writeString(view, 0, 'RIFF');
                view.setUint32(4, 36 + dataSize, true);
                writeString(view, 8, 'WAVE');

                // fmt subchunk
                writeString(view, 12, 'fmt ');
                view.setUint32(16, 16, true);             // Subchunk1Size (16 for PCM)
                view.setUint16(20, 1, true);              // AudioFormat (1 = PCM)
                view.setUint16(22, numChannels, true);    // NumChannels
                view.setUint32(24, sampleRate, true);     // SampleRate
                view.setUint32(28, byteRate, true);       // ByteRate
                view.setUint16(32, blockAlign, true);     // BlockAlign
                view.setUint16(34, bitsPerSample, true);  // BitsPerSample

                // data subchunk
                writeString(view, 36, 'data');
                view.setUint32(40, dataSize, true);

                // PCM data
                let offset = 44;
                for (let i = 0; i < samplesLength; i++) {
                    for (let ch = 0; ch < numChannels; ch++) {
                        let sample = buffer.getChannelData(ch)[i];
                        // [-1,1] 범위의 float를 16-bit PCM으로 변환
                        const s = Math.max(-1, Math.min(1, sample));
                        view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
                        offset += bytesPerSample;
                    }
                }

                return new Blob([view], { type: 'audio/wav' });
            }

            const blob = new Blob(audioChunks, { type: 'audio/webm' });

            // const webmBlob = new Blob(audioChunks, { type: 'audio/webm' });
            // const arrayBuffer = await webmBlob.arrayBuffer();
            // const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
            // const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);
            // const blob = audioBufferToWavBlob(audioBuffer);

            const fd = new FormData();
            fd.append('upload', blob, 'recording.webm');
            fd.append('subject', root.event.get("subject"));

            try {
                const { code, data } = await root.service.file.upload(UPLOAD_URL, fd, async (percent: number, total: number, position: number) => { });
                console.log('✅ 업로드 성공', code, data);
            } catch (err) {
                console.error('업로드 실패:', err);
            }
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            // MediaRecorder 세팅
            mediaRecorder = new MediaRecorder(stream);
            mediaRecorder.ondataavailable = e => {
                if (e.data.size > 0) audioChunks.push(e.data);
            };
            mediaRecorder.onstop = sendAudioToServer;

            // Web Audio API 세팅 (무음 감지용)
            audioContext = new AudioContext();
            sourceNode = audioContext.createMediaStreamSource(stream);
            analyserNode = audioContext.createAnalyser();
            processorNode = audioContext.createScriptProcessor(2048, 1, 1);

            sourceNode.connect(analyserNode);
            analyserNode.connect(processorNode);
            processorNode.connect(audioContext.destination);

            processorNode.onaudioprocess = detectSilence;

            // 녹음 시작
            audioChunks = [];
            mediaRecorder.start();
            console.log('🔴 녹음 자동 시작');

            this.mediaRecorder = mediaRecorder;
            this.processorNode = processorNode;
            this.analyserNode = analyserNode;
            this.sourceNode = sourceNode;
            this.audioContext = audioContext;

        } catch (err) {
            console.error('마이크 접근 실패:', err);
        }
    }

    public async stopRecording() {
        let mediaRecorder = this.mediaRecorder;
        let processorNode = this.processorNode;
        let analyserNode = this.analyserNode;
        let sourceNode = this.sourceNode;
        let audioContext = this.audioContext;

        if (mediaRecorder && mediaRecorder.state === 'recording') {
            mediaRecorder.stop();
            processorNode.disconnect();
            analyserNode.disconnect();
            sourceNode.disconnect();
            audioContext.close();
            console.log('⏹️ 녹음 중지 (무음 감지 또는 버튼)');
        }
    }

    public chatbotUrl() {
        return 'https://llm.baekje.seasonai.net/?page=' + encodeURIComponent(this.event.get("subject"));
    }
}

export default PortalKioskChatComponent;